/**
 * Explanatory note under the Eligible Game Spares section. These players have
 * responded to an availability request but are not on the game roster until
 * they are promoted, which is not obvious from the row actions alone.
 */
// Kept short so it stays on ONE line at the smallest supported phone width —
// a longer sentence wraps to two lines on mobile at this font size.
export const ELIGIBLE_GAME_SPARES_NOTE =
  'Players must be promoted to join the game roster.'

/**
 * Explanatory note under the Roster Spares section (SN-8476). Roster spares sit
 * on the team roster but only play once a team official confirms them for the
 * game — the CONFIRM checkbox. Same one-line limit as the note above.
 */
export const ROSTER_SPARES_NOTE =
  'Players must be confirmed to play in this game.'

/**
 * Help-centre article for game attendance / availability. The help modal (web)
 * and help sheet (mobile) link to it from their "?" icon and description.
 */
export const ATTENDANCE_SUPPORT_URL =
  'https://support.sportninja.com/game-attendance-players'

/**
 * Attendance answer wording (SN-8476). Spares are asked whether they're
 * available to play; rostered players keep the attending wording. Pick a set
 * with `isRosterSpare(player)` (or the section a row sits in).
 */
export const ATTENDANCE_STATUS_LABELS = {
  roster: {
    attending: 'Attending',
    maybe: 'Maybe',
    notAttending: 'Not Attending',
  },
  spare: {
    attending: 'Available',
    maybe: 'Maybe',
    notAttending: 'Not Available',
  },
} as const
